export default {
    tiposLeito: new Array(),
    mapaTipoLeito: null,
    tipoLeitoFiltradoStatus: null,
    leitos: {
        livres: '',
        cedidos: ''
    }
}
